import { IDateRange } from '../../../types/dateRange';

export const defaultState: IDateRange = {
  from: null,
  to: null,
};
